/**
 * collection-filter.js - client-side filter for the camp overview page.
 *
 * Works with sections/collection-overzicht.liquid: all camps are already
 * rendered server-side (grouped by custom.collectie_groep, sorted by
 * custom.start_datum), this script only shows/hides the already-rendered
 * items by data attribute. No extra requests, no dependency.
 *
 * Progressive enhancement: the filter bar ships with inline
 * style="display:none" in the Liquid markup, so a visitor without
 * JavaScript never sees it and always sees every camp. This script reveals
 * the bar and wires it up once it runs.
 *
 * Filter state round-trips through the URL (?stad=...&seizoen=...&type=...)
 * via history.replaceState, so a parent can bookmark or share a filtered
 * view and reloading restores it.
 */
(function () {
  'use strict';

  var FILTER_KEYS = ['stad', 'seizoen', 'type'];

  function initCampFilters(scope) {
    var bar = scope.querySelector('[data-camp-filters]');
    if (!bar) return;

    var selects = {};
    FILTER_KEYS.forEach(function (key) {
      selects[key] = bar.querySelector('[data-camp-filter="' + key + '"]');
    });

    var groups = Array.prototype.slice.call(scope.querySelectorAll('[data-camp-group]'));
    var countEl = scope.querySelector('[data-camp-count]');
    var emptyEl = scope.querySelector('[data-camp-empty]');
    var groupsWrap = scope.querySelector('[data-camp-groups]');
    var resetButtons = Array.prototype.slice.call(scope.querySelectorAll('[data-camp-filter-reset]'));

    function readStateFromUrl() {
      var params = new URLSearchParams(window.location.search);
      FILTER_KEYS.forEach(function (key) {
        var select = selects[key];
        if (!select) return;
        var value = params.get(key) || '';
        var hasOption = false;
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === value) {
            hasOption = true;
            break;
          }
        }
        select.value = hasOption ? value : '';
      });
    }

    function writeStateToUrl() {
      var params = new URLSearchParams(window.location.search);
      FILTER_KEYS.forEach(function (key) {
        var select = selects[key];
        var value = select ? select.value : '';
        if (value) {
          params.set(key, value);
        } else {
          params.delete(key);
        }
      });
      var query = params.toString();
      var newUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
      window.history.replaceState(null, '', newUrl);
    }

    function applyFilters() {
      var active = {};
      FILTER_KEYS.forEach(function (key) {
        active[key] = selects[key] ? selects[key].value : '';
      });

      var visibleCount = 0;

      groups.forEach(function (group) {
        var items = Array.prototype.slice.call(group.querySelectorAll('[data-camp-item]'));
        var groupVisible = 0;
        items.forEach(function (item) {
          var matches = FILTER_KEYS.every(function (key) {
            var value = active[key];
            return !value || item.getAttribute('data-' + key) === value;
          });
          item.style.display = matches ? '' : 'none';
          if (matches) groupVisible++;
        });
        group.style.display = groupVisible === 0 ? 'none' : '';
        visibleCount += groupVisible;
      });

      if (countEl) {
        // Reuse the singular/plural noun the server rendered (data attributes
        // set in sections/collection-overzicht.liquid) so the counter never
        // switches to a different word after client-side filtering.
        var singularNoun = countEl.getAttribute('data-count-singular') || 'resultaat';
        var pluralNoun = countEl.getAttribute('data-count-plural') || 'resultaten';
        countEl.textContent = visibleCount + ' ' + (visibleCount === 1 ? singularNoun : pluralNoun) + ' gevonden';
      }
      if (emptyEl) {
        emptyEl.style.display = visibleCount === 0 ? 'flex' : 'none';
      }
      if (groupsWrap) {
        groupsWrap.style.display = visibleCount === 0 ? 'none' : '';
      }
    }

    FILTER_KEYS.forEach(function (key) {
      var select = selects[key];
      if (!select) return;
      select.addEventListener('change', function () {
        writeStateToUrl();
        applyFilters();
      });
    });

    resetButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        FILTER_KEYS.forEach(function (key) {
          if (selects[key]) selects[key].value = '';
        });
        writeStateToUrl();
        applyFilters();
      });
    });

    readStateFromUrl();
    applyFilters();
    bar.style.display = 'flex';
  }

  function init() {
    var scopes = document.querySelectorAll('.collection-overzicht');
    scopes.forEach(function (scope) {
      initCampFilters(scope);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
